(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["r21-footer-social"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('.r21-collection__categories a').forEach(link=>{
  const target=new URL(link.href),current=new URL(location.href);
  const active=target.pathname===current.pathname&&target.searchParams.get('sort_by')===current.searchParams.get('sort_by');
  if(active)link.setAttribute('aria-current','page');else link.removeAttribute('aria-current');
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["r21-localization"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('.r21-localization').forEach(menu=>{
  const form=menu.querySelector('form'),search=menu.querySelector('input[type="search"]'),rows=[...menu.querySelectorAll('.r21-locale-countries li')];
  search.addEventListener('input',()=>{const value=search.value.trim().toLocaleLowerCase();rows.forEach(row=>row.hidden=!row.textContent.toLocaleLowerCase().includes(value));menu.querySelector('.r21-locale-empty').hidden=rows.some(row=>!row.hidden)});
  menu.querySelector('select').addEventListener('change',()=>form.requestSubmit());
  menu.addEventListener('keydown',event=>{if(event.key==='Escape'){event.preventDefault();menu.open=false;menu.querySelector('summary').focus()}});
  document.addEventListener('pointerdown',event=>{if(!menu.contains(event.target))menu.open=false});
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["r21-navigation-footer"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded',()=>{
  const shell=document.querySelector('.r21-nav-shell'),desktop=matchMedia('(min-width:750px)'),hover=matchMedia('(hover:hover) and (pointer:fine)');
  if(shell){
    const items=[...shell.querySelectorAll('.r21-desktop-nav .r21-nav-item')];
    let exitTimer,planeTimer,active;
    shell.classList.add('r21-menu-managed');
    const cancel=()=>{clearTimeout(exitTimer);clearTimeout(planeTimer)};
    const close=()=>{cancel();shell.classList.remove('r21-nav-emphasis');items.forEach(item=>{item.classList.remove('r21-menu-active');if(item.querySelector('.r21-subnav'))item.querySelector(':scope>a')?.setAttribute('aria-expanded','false')});active=null;planeTimer=setTimeout(()=>shell.classList.remove('r21-menu-surface'),300)};
    const leave=()=>{clearTimeout(exitTimer);exitTimer=setTimeout(close,340)};
    const open=item=>{
      if(!desktop.matches)return;
      const sub=item.querySelector('.r21-subnav');
      cancel();active=item;shell.classList.add('r21-nav-emphasis');
      if(sub){shell.classList.add('r21-menu-surface');shell.style.setProperty('--r21-menu-height',sub.offsetHeight+'px');sub.style.setProperty('--menu-left',item.offsetLeft+'px')}
      else{shell.style.setProperty('--r21-menu-height','0px');planeTimer=setTimeout(()=>shell.classList.remove('r21-menu-surface'),300)}
      items.forEach(entry=>{const selected=entry===item;entry.classList.toggle('r21-menu-active',selected);if(entry.querySelector('.r21-subnav'))entry.querySelector(':scope>a').setAttribute('aria-expanded',String(selected))});
    };
    items.forEach((item,index)=>{
      const sub=item.querySelector('.r21-subnav'),link=item.querySelector(':scope>a');
      if(sub){sub.id=sub.id||'R21Subnav-'+index;link.setAttribute('aria-controls',sub.id);link.setAttribute('aria-expanded','false')}
      item.addEventListener('pointerenter',()=>{if(hover.matches)open(item)});
      item.addEventListener('focusin',()=>open(item));
      item.addEventListener('keydown',event=>{if(event.key==='ArrowDown'&&sub){event.preventDefault();open(item);sub.querySelector('a')?.focus()}if(event.key==='Escape'){event.preventDefault();link.focus();close()}});
    });
    shell.addEventListener('pointerenter',()=>{if(active)cancel()});
    shell.addEventListener('pointerleave',leave);
    shell.addEventListener('focusout',event=>{if(!shell.contains(event.relatedTarget))leave()});
    document.addEventListener('pointerdown',event=>{if(!shell.contains(event.target))close()});
    desktop.addEventListener('change',close);
  }
  document.querySelectorAll('.r21-policy-menu').forEach(menu=>{
    let timer,suppressFocus=false;
    const cancel=()=>clearTimeout(timer);
    menu.addEventListener('pointerenter',()=>{if(hover.matches){cancel();menu.open=true}});
    menu.addEventListener('pointerleave',()=>{cancel();timer=setTimeout(()=>{if(!menu.contains(document.activeElement))menu.open=false},380)});
    menu.addEventListener('focusin',()=>{cancel();if(hover.matches&&!suppressFocus)menu.open=true});
    menu.addEventListener('focusout',event=>{if(!menu.contains(event.relatedTarget)){cancel();timer=setTimeout(()=>menu.open=false,380)}});
    menu.addEventListener('keydown',event=>{if(event.key==='Escape'){suppressFocus=true;cancel();menu.open=false;menu.querySelector('summary').focus();queueMicrotask(()=>suppressFocus=false)}} ,true);
  });
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["r21-parity-system"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded',()=>{
  const confirmation=document.getElementById('r21-bag-confirmation');
  const hide=()=>{confirmation.hidden=true};
  confirmation.querySelector('.r21-confirm-close').addEventListener('click',hide);
  confirmation.querySelector('.r21-confirm-view').addEventListener('click',()=>{hide();document.querySelector('cart-drawer')?.open(document.querySelector('#cart-icon-bubble'))});
  document.addEventListener('keydown',e=>{if(e.key==='Escape'&&!confirmation.hidden){hide();document.querySelector('#cart-icon-bubble')?.focus()}});
  document.addEventListener('click',e=>{if(!confirmation.contains(e.target)&&!e.target.closest('product-form'))hide()});
  let addSequence=0;
  document.addEventListener('click',e=>{const control=e.target.closest('[data-search-scroll]');if(!control)return;const row=control.closest('[data-search-row]').querySelector('.r21-search-links');row.scrollBy({left:row.clientWidth*Number(control.dataset.searchScroll),behavior:matchMedia('(prefers-reduced-motion:reduce)').matches?'instant':'smooth'})});
  document.addEventListener('r21:added',async e=>{
    const {item,button}=e.detail,sequence=++addSequence;
    const label=button.querySelector('span');
    button.classList.add('r21-native-added');
    if(label)label.textContent=confirmation.dataset.added;
    const reset=()=>{button.classList.remove('r21-native-added');if(label?.textContent===confirmation.dataset.added)label.textContent=window.variantStrings.addToCart};
    setTimeout(reset,2200);
    const sourceURL=item.featured_image?.url||item.image||document.querySelector('.product__media img')?.currentSrc;
    let imageURL=sourceURL;
    if(sourceURL){const url=new URL(sourceURL,location.href);url.searchParams.set('width','160');imageURL=url.href}
    const content=confirmation.querySelector('.r21-confirm-item');content.replaceChildren();
    const picture=document.createElement('img');if(imageURL)picture.src=imageURL;picture.alt=item.product_title||item.title;content.append(picture);
    if(imageURL)await Promise.race([picture.decode().catch(()=>{}),new Promise(resolve=>setTimeout(resolve,450))]);
    const copy=document.createElement('div'),title=document.createElement('h2');title.textContent=item.product_title||item.title;copy.append(title);
    (item.options_with_values||[]).forEach(option=>{const p=document.createElement('p');p.textContent=option.name+': '+option.value;copy.append(p)});
    const quantity=document.createElement('p');quantity.textContent=confirmation.dataset.quantity+': '+item.quantity;copy.append(quantity);
    const price=document.createElement('p');price.textContent=new Intl.NumberFormat(document.documentElement.lang||'en',{style:'currency',currency:window.Shopify?.currency?.active||'USD'}).format(item.final_price/100);copy.append(price);content.append(copy);
    const target=document.querySelector('#cart-icon-bubble');
    if(imageURL&&target&&!matchMedia('(prefers-reduced-motion:reduce)').matches){
      const start=button.getBoundingClientRect(),end=target.getBoundingClientRect(),fly=picture.cloneNode();fly.className='r21-flying-product';fly.alt='';fly.setAttribute('aria-hidden','true');document.body.append(fly);
      const x=start.x+start.width/2-23,y=start.y+start.height/2-30,dx=end.x+end.width/2-23-x,dy=end.y+end.height/2-30-y;
      fly.style.left=x+'px';fly.style.top=y+'px';
      const frames=Array.from({length:31},(_,i)=>{const t=i/30,u=1-t;return{transform:`translate(${3*u*t*t*dx*.45+t*t*t*dx}px,${3*u*u*t*dy*.72+3*u*t*t*dy+t*t*t*dy}px) scale(${1-.75*t})`,opacity:1-.65*t}});
      try{await fly.animate(frames,{duration:760,easing:'cubic-bezier(.22,.61,.36,1)'}).finished}finally{fly.remove()}
    }
    if(sequence===addSequence)confirmation.hidden=false;
  });
  document.addEventListener('click',e=>{const toggle=e.target.closest('[data-r21-filters]');if(!toggle)return;const grid=toggle.closest('r21-collection-grid'),open=grid.classList.toggle('r21-filters-open');toggle.setAttribute('aria-expanded',String(open))});
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["r21-pdp-refinements"] && !Shopify.designMode) return;
  try {
    (() => {
  const ready = new WeakSet();
  const move = (field, animate = true) => {
    const label = field.querySelector('input:checked + label');
    if (!label) return;
    field.classList.add('r21-size-slider');
    const track = field.querySelector('.r21-size-track');
    const box = track.getBoundingClientRect(), target = label.getBoundingClientRect();
    const x = target.left - box.left, y = target.top - box.top;
    const fresh = !ready.has(field);
    const indicator = track.querySelector('.r21-size-indicator');
    const immediate = fresh || !animate;
    if (immediate) indicator.style.transition = 'none';
    indicator.style.top = y + 'px';
    indicator.style.width = target.width + 'px';
    indicator.style.height = target.height + 'px';
    indicator.style.transform = `translateX(${x}px)`;
    if (immediate) {
      indicator.getBoundingClientRect();
      indicator.style.removeProperty('transition');
    }
    ready.add(field);
  };
  const init = () => document.querySelectorAll('variant-selects .product-form__input--pill').forEach(field => {
    if (!ready.has(field) && field.getClientRects().length && /^(size|尺码|尺寸):?$/i.test(field.querySelector('legend')?.textContent.trim() || '')) {
      field.querySelector('legend').textContent = 'SIZE:';
      const track = document.createElement('div');track.className = 'r21-size-track';
      const indicator = document.createElement('span');indicator.className='r21-size-indicator';indicator.setAttribute('aria-hidden','true');
      track.append(indicator);
      [...field.children].filter(child=>child.tagName!=='LEGEND').forEach(child=>track.append(child));
      field.append(track);move(field);
    }
  });
  document.addEventListener('change', event => {
    const field = event.target.closest('.r21-size-slider');
    if (field) move(field);
  }, true);
  let frame;
  new MutationObserver(() => {cancelAnimationFrame(frame);frame = requestAnimationFrame(init)}).observe(document.querySelector('main') || document.body, {childList:true,subtree:true});
  window.addEventListener('resize', () => document.querySelectorAll('.r21-size-slider').forEach(field => move(field, false)));
  init();
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["r21-pdp-vertical-slice"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('r21-sticky-purchase')) {
    customElements.define(
      'r21-sticky-purchase',
      class extends HTMLElement {
        connectedCallback() {
          this.hasSeenSource = false;
          this.stickyButton = this.querySelector('[data-sticky-submit]');
          this.stickyButton?.addEventListener('click', () => this.sourceButton?.click());
          this.productInfo = this.closest('product-info');
          this.infoPanel = this.productInfo?.querySelector('.product__info-container');
          this.mutationObserver = new MutationObserver(() => this.sync());
          if (this.infoPanel) this.mutationObserver.observe(this.infoPanel, { childList: true, subtree: true });
          this.formatCounters();
          this.counterObserver = new MutationObserver(() => this.formatCounters());
          this.productInfo?.querySelectorAll('.slider-counter--current, .slider-counter--total').forEach((counter) => {
            this.counterObserver.observe(counter, { childList: true, characterData: true, subtree: true });
          });
          this.sync();
        }

        disconnectedCallback() {
          this.intersectionObserver?.disconnect();
          this.mutationObserver?.disconnect();
          this.counterObserver?.disconnect();
        }

        sync() {
          const nextSource = this.productInfo?.querySelector(`#${CSS.escape(this.dataset.sourceButton)}`);
          if (nextSource && nextSource !== this.sourceButton) {
            this.sourceButton = nextSource;
            this.intersectionObserver?.disconnect();
            this.intersectionObserver = new IntersectionObserver(([entry]) => {
              if (entry.isIntersecting) this.hasSeenSource = true;
              this.hidden = entry.isIntersecting || !this.hasSeenSource;
            });
            this.intersectionObserver.observe(this.sourceButton);
          }

          if (!this.sourceButton || !this.stickyButton) return;
          this.stickyButton.disabled = this.sourceButton.disabled;
          const sourceLabel = this.sourceButton.querySelector('span');
          const stickyLabel = this.querySelector('[data-sticky-label]');
          if (sourceLabel && stickyLabel && stickyLabel.textContent !== sourceLabel.textContent.trim()) stickyLabel.textContent = sourceLabel.textContent.trim();

          const priceSource = this.productInfo?.querySelector(`#${CSS.escape(this.dataset.priceSource)} .price__container`);
          const stickyPrice = this.querySelector('[data-sticky-price]');
          if (priceSource && stickyPrice && stickyPrice.textContent !== priceSource.textContent.replace(/\s+/g, ' ').trim()) stickyPrice.textContent = priceSource.textContent.replace(/\s+/g, ' ').trim();
        }

        formatCounters() {
          const gallery = this.productInfo?.querySelector('media-gallery');
          const galleryTotal = gallery?.querySelector('.slider-counter--total');
          const galleryCurrent = gallery?.querySelector('.slider-counter--current');
          const visibleSlides = gallery
            ? Array.from(gallery.querySelectorAll('[id^="Slide-"]')).filter((slide) => slide.clientWidth > 0)
            : [];

          if (galleryTotal && visibleSlides.length > 0) {
            const totalLabel = String(visibleSlides.length).padStart(2, '0');
            if (galleryTotal.textContent !== totalLabel) galleryTotal.textContent = totalLabel;
            const currentValue = Number.parseInt(galleryCurrent?.textContent, 10);
            if (galleryCurrent && Number.isFinite(currentValue)) {
              const currentLabel = String(Math.min(currentValue, visibleSlides.length)).padStart(2, '0');
              if (galleryCurrent.textContent !== currentLabel) galleryCurrent.textContent = currentLabel;
            }
          }

          this.productInfo?.querySelectorAll('.slider-counter--current, .slider-counter--total').forEach((counter) => {
            const value = Number.parseInt(counter.textContent, 10);
            const formattedValue = String(value).padStart(2, '0');
            if (Number.isFinite(value) && counter.textContent !== formattedValue) counter.textContent = formattedValue;
          });
        }
      },
    );
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["r21-presentation-fixes"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('.search-modal').forEach(modal=>{
  const input=modal.querySelector('input[type="search"]');
  const link=modal.querySelector('.r21-search-fixed-view');
  if(!input||!link)return;
  const initial=link.href;
  const update=()=>{link.href=input.value.trim()?`${link.dataset.searchUrl}?q=${encodeURIComponent(input.value.trim())}&options%5Bprefix%5D=last`:initial};
  input.addEventListener('input',update);
  input.form.addEventListener('reset',()=>requestAnimationFrame(update));
});
document.addEventListener('r21:variant-updated',event=>{
  if(matchMedia('(prefers-reduced-motion: reduce)').matches)return;
  event.target.querySelectorAll('variant-selects [data-selected-value],variant-selects input:checked+label').forEach(label=>label.animate([{opacity:.45},{opacity:1}],{duration:220,easing:'ease-out'}));
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["r21-release-system"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded',()=>{
 const header=document.querySelector('.header-wrapper'),home=document.querySelector('.r21-home-sequence'),footer=document.querySelector('.r21-release-footer'),logo=document.querySelector('.r21-release-logo');
 if(!header)return;
 const isHome=document.body.classList.contains('r21-page-type--index');
 let last=scrollY,anchor=scrollY,hidden=false,frame=0;
 const update=()=>{
   const y=isHome?scrollY:Math.max(0,Math.min(scrollY,document.documentElement.scrollHeight-innerHeight)),down=y>=last;
   last=y;
   const onCover=home&&(innerWidth<750||y>150)&&(!footer||y<footer.offsetTop-80);
   header.classList.toggle('r21-over-image',!!onCover);
   if(isHome){
     header.classList.toggle('r21-scroll-hidden',y>300&&!down&&!header.contains(document.activeElement));
   }else{
     const delta=y-anchor;
     if(y<=header.offsetHeight){hidden=false;anchor=y}
     else if(Math.abs(delta)>=4){hidden=delta>0;anchor=y}
     const interacting=header.querySelector(':focus-visible, details[open]');
     header.classList.toggle('r21-scroll-hidden',hidden&&!interacting);
   }
   if(logo&&innerWidth>=750){const progress=home?Math.max(0,1-y/230):0;logo.style.setProperty('--logo-scale',String(1+1.69*progress));logo.style.setProperty('--logo-y',53*progress+'px')}
   frame=0;
 };
 addEventListener('scroll',()=>{if(!frame)frame=requestAnimationFrame(update)},{passive:true});update();
 addEventListener('resize',()=>{if(!frame)frame=requestAnimationFrame(update)},{passive:true});
 header.addEventListener('focusin',()=>header.classList.remove('r21-scroll-hidden'));
 document.querySelectorAll('.r21-nav-item').forEach(item=>{const sub=item.querySelector('.r21-subnav');if(sub){const align=()=>sub.style.setProperty('--menu-left',item.offsetLeft+'px');item.addEventListener('mouseenter',align);item.addEventListener('focusin',align)}});
 document.querySelectorAll('.r21-policy-menu,.r21-mobile-nav').forEach(menu=>{menu.addEventListener('keydown',e=>{if(e.key==='Escape'){menu.open=false;menu.querySelector('summary').focus()}});document.addEventListener('click',e=>{if(!menu.contains(e.target))menu.open=false})});
 const grid=document.querySelector('r21-collection-grid');
 if(grid){grid.addEventListener('click',e=>{const button=e.target.closest('[data-r21-view]');if(!button)return;grid.classList.toggle('r21-product-mode',button.dataset.r21View==='product');grid.querySelectorAll('[data-r21-view]').forEach(b=>b.setAttribute('aria-pressed',String(b===button)))})}
 if(home&&home.dataset.stepped==='true'&&!window.Shopify?.designMode){
  let busy=false,idle=0,reset=0;
  const targets=()=>[0,...Array.from(home.querySelectorAll('.r21-home-cover'),e=>e.getBoundingClientRect().top+scrollY),...(footer?[footer.offsetTop]:[])].filter((n,i,a)=>!i||n!==a[i-1]);
  const step=direction=>{const points=targets(),index=points.reduce((best,n,i)=>Math.abs(n-scrollY)<Math.abs(points[best]-scrollY)?i:best,0),next=Math.max(0,Math.min(points.length-1,index+direction));if(next===index)return;busy=true;const from=scrollY,to=points[next],start=performance.now(),duration=matchMedia('(prefers-reduced-motion:reduce)').matches?0:760;const tick=now=>{const t=duration?Math.min(1,(now-start)/duration):1;scrollTo(0,from+(to-from)*(1-Math.pow(1-t,3)));if(t<1)requestAnimationFrame(tick);else{busy=false;idle=performance.now()}};requestAnimationFrame(tick)};
  const exempt=el=>el.closest('input,textarea,select,button,summary,dialog,cart-drawer,.r21-mobile-nav,.search-modal');
  addEventListener('wheel',e=>{if(e.ctrlKey||Math.abs(e.deltaX)>Math.abs(e.deltaY)||exempt(e.target))return;if(footer&&scrollY>=footer.offsetTop-2&&e.deltaY>0)return;e.preventDefault();clearTimeout(reset);reset=setTimeout(()=>idle=0,180);if(busy||idle||Math.abs(e.deltaY)<8)return;step(Math.sign(e.deltaY))},{passive:false});
  addEventListener('keydown',e=>{if(exempt(e.target)||e.target.closest('a'))return;const direction=['ArrowDown','PageDown',' '].includes(e.key)?1:['ArrowUp','PageUp'].includes(e.key)?-1:0;if(direction){e.preventDefault();if(!busy)step(direction)}});
 }
});
  } catch(e) { console.error(e); }
})();

})();
